import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import 'react';
import { themed } from '@indeed/ifl-css';
import { usePopoverContext } from './context.js';
import { jsx } from '@emotion/react';
import { Divider } from '../Divider/Divider.js';
import { Stack, StackItem } from '../Stack/Stack.js';
import '@indeed/ihl-use-id';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '../../utils/warnDeprecation.js';
import '../../utils/warn.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../../utils/displayName.js';

const Container = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: [],
  target: "e2ktig30"
} : {
  styleProps: [],
  target: "e2ktig30",
  label: "Container"
})(() => ({
  boxSizing: "border-box",
  marginBlockStart: 5,
  marginBlockEnd: -2,
  marginInlineStart: 0,
  marginInlineEnd: 0,
  minInlineSize: 0
}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBvcG92ZXJGb290ZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFrQiIsImZpbGUiOiJQb3BvdmVyRm9vdGVyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBQcm9wc1dpdGhDaGlsZHJlbiB9IGZyb20gXCJyZWFjdFwiO1xuaW1wb3J0IHsgRGl2aWRlciB9IGZyb20gXCIuLi9EaXZpZGVyXCI7XG5pbXBvcnQgeyBTdGFjaywgU3RhY2tJdGVtIH0gZnJvbSBcIi4uL1N0YWNrXCI7XG5pbXBvcnQgeyB0aGVtZWQsIFN0eWxlUHJvcHMgfSBmcm9tIFwiQGluZGVlZC9pZmwtY3NzXCI7XG5pbXBvcnQgeyB1c2VQb3BvdmVyQ29udGV4dCB9IGZyb20gXCIuL2NvbnRleHRcIjtcblxuZXhwb3J0IHR5cGUgUG9wb3ZlckZvb3RlclByb3BzID0gU3R5bGVQcm9wcztcblxuY29uc3QgQ29udGFpbmVyID0gdGhlbWVkKFwiZGl2XCIsIHsgc3R5bGVQcm9wczogW10gfSkoKCkgPT4gKHtcbiAgYm94U2l6aW5nOiBcImJvcmRlci1ib3hcIixcbiAgbWFyZ2luQmxvY2tTdGFydDogNSxcbiAgbWFyZ2luQmxvY2tFbmQ6IC0yLFxuICBtYXJnaW5JbmxpbmVTdGFydDogMCxcbiAgbWFyZ2luSW5saW5lRW5kOiAwLFxuICBtaW5JbmxpbmVTaXplOiAwXG59KSk7XG5cbi8qKlxuICogUG9wb3ZlckZvb3RlclxuICpcbiAqIEBkZXByZWNhdGVkIFRoZSBgUG9wb3ZlcmAgY29tcG9uZW50IHdpbGwgYmUgcmVtb3ZlZCBpbiBJRkwgNy5cbiAqIFNlZSB0aGUgSUZMIDcgcHJlcGFyYXRpb24gZ3VpZGUgZm9yIG1vcmUgaW5mb3JtYXRpb246IGh0dHBzOi8vbGluay5pbmRlZWQudGVjaC9pZmwtNy1wcmVwLWd1aWRlXG4gKiovXG5leHBvcnQgY29uc3QgUG9wb3ZlckZvb3RlcjogUmVhY3QuRkM8UHJvcHNXaXRoQ2hpbGRyZW48UG9wb3ZlckZvb3RlclByb3BzPj4gPVxuICBwcm9wcyA9PiB7XG4gICAgY29uc3QgeyBpc01vYmlsZSB9ID0gdXNlUG9wb3ZlckNvbnRleHQoKTtcblxuICAgIHJldHVybiAoXG4gICAgICA8Q29udGFpbmVyIHsuLi5wcm9wc30+XG4gICAgICAgIDxEaXZpZGVyXG4gICAgICAgICAgc3g9e3tcbiAgICAgICAgICAgIG1hcmdpbklubGluZVN0YXJ0OiAtNSxcbiAgICAgICAgICAgIG1hcmdpbklubGluZUVuZDogLTUsXG4gICAgICAgICAgICBtYXJnaW5CbG9ja1N0YXJ0OiAwLFxuICAgICAgICAgICAgbWFyZ2luQmxvY2tFbmQ6IDAsXG4gICAgICAgICAgICBpbmxpbmVTaXplOiAoeyBzcGFjZSB9KSA9PiBgY2FsYygxMDAlICsgMioke3NwYWNlWzVdfSlgXG4gICAgICAgICAgfX1cbiAgICAgICAgLz5cbiAgICAgICAgPFN0YWNrXG4gICAgICAgICAgc3g9e3tcbiAgICAgICAgICAgIHBhZGRpbmdCbG9ja1N0YXJ0OiA0LFxuICAgICAgICAgICAgW2AmID4gJHtTdGFja0l0ZW19ID4gKmBdOiB7XG4gICAgICAgICAgICAgIGlubGluZVNpemU6IFwiMTAwJVwiXG4gICAgICAgICAgICB9XG4gICAgICAgICAgfX1cbiAgICAgICAgICB2ZXJ0aWNhbD17aXNNb2JpbGV9XG4gICAgICAgICAgYWxpZ25tZW50PXtpc01vYmlsZSA/IFwiZmlsbFwiIDogXCJzdGFydFwifVxuICAgICAgICAgIGRpc3RyaWJ1dGlvbj1cImVuZFwiXG4gICAgICAgICAgey4uLnByb3BzfVxuICAgICAgICAvPlxuICAgICAgPC9Db250YWluZXI+XG4gICAgKTtcbiAgfTtcblxuUG9wb3ZlckZvb3Rlci5kaXNwbGF5TmFtZSA9IFwiUG9wb3ZlckZvb3RlclwiO1xuIl19 */");

/**
 * PopoverFooter
 *
 * @deprecated The `Popover` component will be removed in IFL 7.
 * See the IFL 7 preparation guide for more information: https://link.indeed.tech/ifl-7-prep-guide
 **/
const PopoverFooter = props => {
  const {
    isMobile
  } = usePopoverContext();
  return jsx(Container, props, jsx(Divider, {
    sx: {
      marginInlineStart: -5,
      marginInlineEnd: -5,
      marginBlockStart: 0,
      marginBlockEnd: 0,
      inlineSize: _ref => {
        let {
          space
        } = _ref;
        return `calc(100% + 2*${space[5]})`;
      }
    }
  }), jsx(Stack, _extends({
    sx: {
      paddingBlockStart: 4,
      [`& > ${StackItem} > *`]: {
        inlineSize: "100%"
      }
    },
    vertical: isMobile,
    alignment: isMobile ? "fill" : "start",
    distribution: "end"
  }, props)));
};
PopoverFooter.displayName = "PopoverFooter";

export { PopoverFooter };
